import { Trash2 } from "lucide-react";
import { t } from "../../i18n";
import { MOROCCO } from "../../lib/countries";
import { Choice, PhoneField } from "./Controls";
import { dialFor } from "./dial";

export const GiftHeader = ({ locale, g, idx, onRemove }) => (
  <div className="flex items-start gap-3">
    <img src={g.image} alt="" className="w-16 aspect-[4/5] object-cover rounded-sm" />
    <div className="text-sm flex-1">
      <p className="smallcaps">{t(locale, "giftFor")} {idx + 1}</p>
      <p className="text-ink">{g.title} · {g.variant_name}</p>
      <p className="text-xs text-muted">{g.city?.name} · {g.zone_name}</p>
      <p className="text-xs text-muted" data-testid={`recipient-morocco-note-${idx}`}>
        {MOROCCO.flag} {t(locale, "moroccoOnly")}
      </p>
    </div>
    <button data-testid={`remove-gift-${idx}`} onClick={onRemove}
            title={t(locale, "removeLine")} aria-label={t(locale, "removeLine")}
            className="text-muted hover:text-danger transition-colors">
      <Trash2 size={16} />
    </button>
  </div>
);

export const SavedRecipientSelect = ({ locale, idx, matching, onPick }) => (
  <select data-testid={`saved-recipient-select-${idx}`} className="field"
          onChange={(e) => { const s = matching.find((x) => x.id === e.target.value); if (s) onPick(s); }}>
    <option value="">{t(locale, "useSaved")}</option>
    {matching.map((s) => <option key={s.id} value={s.id}>{`${s.name} — ${s.zone_name}`}</option>)}
  </select>
);

export const RecipientContact = ({ locale, idx, r, errs, set, countryList, answerRequired }) => {
  const waCountry = r.whatsapp_country || r.phone_country || "MA";
  return (
    <div className="grid sm:grid-cols-2 gap-4 items-end">
      <div className="space-y-1">
        <label className="smallcaps">{t(locale, "fullName")}</label>
        <input data-testid={`recipient-name-${idx}`} className="field" value={r.name} enterKeyHint="next"
               onChange={(e) => set("name", e.target.value)} />
        {r.name && errs.name ? <p className="text-danger text-xs" data-testid={`recipient-name-error-${idx}`}>{errs.name}</p> : null}
      </div>
      <div className="space-y-1">
        <label className="smallcaps">{t(locale, "phone")}</label>
        <PhoneField dialTestid={`recipient-dial-${idx}`} dialLabel={t(locale, "phone")} list={countryList}
                    country={r.phone_country || "MA"} onCountry={(v) => set("phone_country", v)}
                    inputProps={{ "data-testid": `recipient-phone-${idx}`, inputMode: "tel", autoComplete: "tel-national",
                                  placeholder: dialFor(r.phone_country) === "+212" ? "6 12 34 56 78" : "", value: r.phone,
                                  onChange: (e) => set("phone", e.target.value) }} />
        {r.phone && errs.phone ? <p className="text-danger text-xs" data-testid={`recipient-phone-error-${idx}`}>{errs.phone}</p> : null}
      </div>
      <div className="space-y-1">
        <label className="smallcaps">{t(locale, "waQuestion")}</label>
        <div className="flex gap-2">
          <Choice on={r.wa_same === true} testid={`wa-yes-${idx}`} label={t(locale, "yes")} onClick={() => set("wa_same", true)} />
          <Choice on={r.wa_same === false} testid={`wa-no-${idx}`} label={t(locale, "no")} onClick={() => set("wa_same", false)} />
        </div>
        {r.wa_same === undefined && <p role="status" className="text-danger text-xs" data-testid={`wa-question-error-${idx}`}>{answerRequired}</p>}
      </div>
      {r.wa_same === false ? (
        <div className="space-y-1" data-testid={`whatsapp-block-${idx}`}>
          <label className="smallcaps">{t(locale, "waNumberLabel")}</label>
          <PhoneField dialTestid={`recipient-whatsapp-dial-${idx}`} dialLabel={t(locale, "waNumberLabel")} list={countryList}
                      country={waCountry} onCountry={(v) => set("whatsapp_country", v)}
                      inputProps={{ "data-testid": `recipient-whatsapp-${idx}`, inputMode: "tel",
                                    placeholder: dialFor(waCountry) === "+212" ? "6 12 34 56 78" : "", value: r.whatsapp,
                                    onChange: (e) => set("whatsapp", e.target.value) }} />
          {r.whatsapp && errs.whatsapp ? <p className="text-danger text-xs" data-testid={`recipient-whatsapp-error-${idx}`}>{errs.whatsapp}</p> : null}
        </div>
      ) : null}
    </div>
  );
};
